/**
 * Socket Connection Wrapper
 *
 * Handles socket.io connection with demo mode support
 */

import socketIOClient from 'socket.io-client';
import { getMockSocket } from './mockSocket';

const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

/**
 * Create socket connection
 * Returns mock socket in demo mode, real socket otherwise
 */
export function createSocketConnection(uri) {
  if (isDemoMode || !uri) {
    console.log('[DEMO MODE] Using mock socket');
    return getMockSocket();
  }

  console.log('[PRODUCTION MODE] Using real socket.io connection');
  // Websocket only (#125): the default HTTP long-polling handshake needs every
  // request of a session to reach the same backend instance. Cloud Run spreads
  // them, the other instance answers 400 (unknown session) and the tab
  // reconnects every 1–2 s — missing events. A websocket is one connection,
  // pinned to one instance for its whole life.
  return socketIOClient(uri, { transports: ['websocket'] });
}

// Export for direct use
export const socket = createSocketConnection(process.env.REACT_APP_SOCKET_URI || '');
